<template>
  <div class="" id="goods">
    <div class="top">
      <NavTop activeIndex="3"></NavTop>
    </div>

    <div
      class=""
      style="
        width: 1000px;
        margin: 100px auto 0;
        min-height: 600px;
        background-color: #fff;
        padding: 30px 60px;
      "
    >
      <div class="" style="font-size: 28px; font-weight: bold">重置密码</div>

      <el-form
        :model="LoginUser"
        status-icon
        ref="ruleForm"
        class="demo-ruleForm"
        style="padding: 0 15px"
      >
        <el-form-item prop="name">
          <div
            class=""
            style="
              display: flex;
              display: flex;
              align-items: center;
              border-bottom: 1px solid #e6e6e6;
            "
          >
            <div
              class=""
              style="
                line-height: 20px;
                border: 1px solid #fff;
                height: 20px;
                box-sizing: border-box;
                margin-right: 10px;
              "
            >
              +86
            </div>
            <div class="" style="flex: 1">
              <el-input
                type="idcard"
                placeholder="请输入手机号"
                v-model="LoginUser.name"
                maxlength="11"
              ></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="pass">
          <div class="pass-box" style="display: flex;justify-content: space-between;">
            <div class="" style="border-bottom: 1px solid #e6e6e6;flex: 1;margin-right: 10px;">
              <el-input type="number" placeholder="请输入验证码" v-model="LoginUser.code" size="mini"
                maxlength="6"></el-input>
            </div>
            <div class="" @click="getCode" style="position: relative;width: 84px;">
              <div class=""
                style="color: #000;cursor: pointer;background-color: #eee;position: absolute;width: 84px;right: 0;height: 27px;line-height: 27px;text-align: center;bottom: 0;border-radius: 4px;">
                {{ buttonText }}</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="name">
          <div
            class=""
            style="
              display: flex;
              display: flex;
              align-items: center;
              border-bottom: 1px solid #e6e6e6;
            "
          >
            <div class="" style="flex: 1">
              <el-input
                type="idcard"
                placeholder="请输入新密码"
                v-model="LoginUser.pass"
                maxlength="11"
              ></el-input>
            </div>
          </div>
        </el-form-item>

        <div class="" style="margin-top: 35px; margin-bottom: 10px">
          <div class="">
            <el-button
              size="medium"
              type="info"
              style="
                width: 270px;
                height: 40px;
                padding: 0;
                border-radius: 5px;
                background-color: #4b72f6;
                border: none;
                color: #666 !important;
              "
              round
              @click="goret"
              >提交</el-button
            >
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import NavTop from "../components/NavTopWhit.vue";
import { forgotPassword, sendCode } from "../api/user";
import Cookies from "js-cookie";

export default {
  components: {
    NavTop,
  },
  data() {
    return {
      LoginUser: {
        name: "",
        code: "",
        pass: "",
      },
      buttonText: "获取验证码",
      sended: false,
    };
  },
  methods: {
    goret() {
      if (!this.LoginUser.name) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (!this.LoginUser.code) {
        this.$message({
          message: '请输入验证码',
          type: 'warning'
        });
        return
      }
      if (!this.LoginUser.pass) {
        this.$message({
          message: "请输入新密码",
          type: "warning",
        });
        return;
      }
      forgotPassword({
        newpassword: this.LoginUser.pass,
        mobile: this.LoginUser.name,
        code: this.LoginUser.code,
      }).then((res) => {
        this.$message({
          message: "重置成功,请重新登录",
          type: "success",
        });
        setTimeout(() => {
          localStorage.clear();
          this.LoginUser.name = "";
          this.LoginUser.pass = "";
          Cookies.remove("token");
          this.tim.logout();
          this.$forceUpdate();
          this.$router.go(0); // 刷新当前页面
        }, 1000);
      });
    },
    getCode() {
      // const userNameRule = /^1[3456789]\d{9}$/;
      // if (!userNameRule.test(this.LoginUser.name)) {
      //   this.$message({
      //     message: '请输入正确手机号',
      //     type: 'warning'
      //   });
      //   return
      // }
      if (!this.LoginUser.name) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (this.buttonText != "获取验证码") {
        this.$message({
          message: "倒计时结束之后再发送",
          type: "warning",
        });
        return;
      }
      sendCode({
        mobile: this.LoginUser.name,
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          console.log(res);
          this.sended = true;
          this.buttonText = "已发送";
          let countDown = 60;
          const timer = setInterval(() => {
            if (countDown > 0) {
              this.buttonText = `${countDown}s 后重试`;
            } else {
              this.sended = false;
              this.buttonText = "获取验证码";
              clearInterval(timer);
            }
            countDown--;
          }, 1000);
          console.log("验证码已发送");
        } else {
          this.notifyError(res.msg);
        }
      });
    },
  },
};
</script>
<style>
.active {
  background-color: #4b72f6 !important;
}

.el-form {
  width: 300px;
  margin: 80px auto;
}
</style>
